import React from "react";
import PropTypes from "prop-types";

import Filters from "../../../../components/Filter";

const EventsListViewFilter = ({
  labels,
  searchInput,
  onSearchChange,
  selectedCompany,
  onCompanyChange,
  companyOptions,
  companiesLoading,
  selectedCity,
  onCityChange,
  cityOptions,
  crewSizeLabel,
  selectedCrewSize,
  onCrewSizeChange,
  crewSizeOptions,
  selectedProjectManager,
  onProjectManagerChange,
  projectManagerOptions,
  selectedPublishingMode,
  onPublishingModeChange,
  publishingModeOptions,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  clearFilters,
  endDateBeforeStart,
  isPayroll,
  hideAdminFilters,
}) => (
  <Filters
    searchInput={{
      placeholder: isPayroll ? labels.searchPlaceHolder : labels.searchByNameOrId,
      name: "eventsSearch",
      value: searchInput,
      onChange: onSearchChange,
    }}
    filters={[
      !isPayroll &&
        !hideAdminFilters && {
        type: "filter",
        name: "company",
        placeholder: labels.companyName,
        label: labels.companyName,
        wrapperClass: "events-list-view__filter-field",
        value: selectedCompany,
        options: companyOptions,
        disabled: companiesLoading,
        showOptionTooltip: true,
        onChange: onCompanyChange,
      },
      !isPayroll &&
        !hideAdminFilters && {
        type: "filter",
        name: "city",
        placeholder: labels.city,
        label: labels.city,
        wrapperClass: "events-list-view__filter-field",
        value: selectedCity,
        options: cityOptions,
        onChange: onCityChange,
      },
      !isPayroll &&
        !hideAdminFilters && {
        type: "filter",
        name: "crewSize",
        placeholder: crewSizeLabel,
        label: crewSizeLabel,
        wrapperClass: "events-list-view__filter-field",
        value: selectedCrewSize,
        options: crewSizeOptions,
        onChange: onCrewSizeChange,
      },
      {
        type: "date",
        name: "startDate",
        placeholder: labels.startDate,
        label: labels.startDate,
        wrapperClass: "events-list-view__filter-field",
        value: startDate,
        onChange: onStartDateChange,
        clearfilters: clearFilters,
      },
      {
        type: "date",
        name: "endDate",
        placeholder: labels.endDate,
        label: labels.endDate,
        wrapperClass: "events-list-view__filter-field",
        value: endDate,
        onChange: onEndDateChange,
        clearfilters: clearFilters,
        isInputHasErr: endDateBeforeStart,
        errMsg: "endDateBeforeStartDate",
      },
      isPayroll && {
        type: "filter",
        name: "projectManager",
        placeholder: labels.projectManager,
        label: labels.projectManager,
        wrapperClass: "events-list-view__filter-field",
        value: selectedProjectManager,
        options: projectManagerOptions,
        onChange: onProjectManagerChange,
      },
      isPayroll && {
        type: "filter",
        name: "publishMode",
        placeholder: labels.publishMode,
        label: labels.publishMode,
        wrapperClass: "events-list-view__filter-field",
        value: selectedPublishingMode,
        options: publishingModeOptions,
        onChange: onPublishingModeChange,
      },
    ].filter(Boolean)}
    classNames={{
      container: "events-list-view__filters",
      base: "",
      search: "mb-3 mb-md-0",
      filter: "",
    }}
  />
);

EventsListViewFilter.propTypes = {
  labels: PropTypes.shape({
    searchByNameOrId: PropTypes.any,
    searchPlaceHolder: PropTypes.any,
    companyName: PropTypes.any,
    city: PropTypes.any,
    startDate: PropTypes.any,
    endDate: PropTypes.any,
    projectManager: PropTypes.any,
    publishMode: PropTypes.any,
  }).isRequired,
  searchInput: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
  selectedCompany: PropTypes.any,
  onCompanyChange: PropTypes.func.isRequired,
  companyOptions: PropTypes.array.isRequired,
  companiesLoading: PropTypes.bool.isRequired,
  selectedCity: PropTypes.any,
  onCityChange: PropTypes.func.isRequired,
  cityOptions: PropTypes.array.isRequired,
  crewSizeLabel: PropTypes.string.isRequired,
  selectedCrewSize: PropTypes.any,
  onCrewSizeChange: PropTypes.func.isRequired,
  crewSizeOptions: PropTypes.array.isRequired,
  selectedProjectManager: PropTypes.any,
  onProjectManagerChange: PropTypes.func,
  projectManagerOptions: PropTypes.array,
  selectedPublishingMode: PropTypes.any,
  onPublishingModeChange: PropTypes.func,
  publishingModeOptions: PropTypes.array,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
  clearFilters: PropTypes.bool.isRequired,
  endDateBeforeStart: PropTypes.bool,
  isPayroll: PropTypes.bool,
  hideAdminFilters: PropTypes.bool,
};

EventsListViewFilter.defaultProps = {
  selectedCompany: null,
  selectedCity: null,
  selectedCrewSize: null,
  selectedProjectManager: null,
  onProjectManagerChange: undefined,
  projectManagerOptions: [],
  selectedPublishingMode: null,
  onPublishingModeChange: undefined,
  publishingModeOptions: [],
  endDateBeforeStart: false,
  isPayroll: false,
  hideAdminFilters: false,
};

export default EventsListViewFilter;
